<template>
  <div class="currencies">
    <v-row
      class="pa-4"
    >
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="text-subtitle-1 font-weight-bold">{{ $t('currencies.title') }}</v-card-title>
          <v-card-text>
            <template v-for="(currency, index) in currencies">
              <div class="currency d-flex align-center justify-space-between" :key="`currency-${index}`">
                <span>{{ currency.description }}</span>
                <v-switch
                  v-model="currency.active"
                  :loading="currency.loading"
                  :disabled="currency.description === 'EUR' || currency.loading"
                  @change="currencyChange(currency)"
                />
              </div>
              <v-divider
                v-if="index !== currencies.length - 1"
                :key="`divider-${index}`"
              />
            </template>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="text-subtitle-1 font-weight-bold">{{ $t('currencies.exchangeRates.title') }}</v-card-title>
          <v-card-subtitle class="text-caption">{{ $t('currencies.exchangeRates.subtitle') }}</v-card-subtitle>
          <v-card-text>
            <template v-for="(rate, index) in exchangeRates">
              <div class="exchange-rate d-flex align-center justify-space-between py-2" :key="`rate-${index}`">
                <span class="font-weight-medium">{{ rate.currencyName }}</span>
                <div class="d-flex align-center">
                  <v-text-field
                    v-model="rate.exchangeRate"
                    type="number"
                    step="0.0001"
                    min="0"
                    dense
                    outlined
                    hide-details
                    style="max-width: 150px;"
                    :suffix="$t('currencies.exchangeRates.toEUR')"
                    :loading="rate.loading"
                    :disabled="rate.loading"
                    @blur="updateExchangeRate(rate)"
                  />
                </div>
              </div>
              <div v-if="rate.lastUpdated && rate.lastUpdated !== '0001-01-01T00:00:00'" :key="`rate-date-${index}`" class="text-caption grey--text mb-2">
                {{ $t('currencies.exchangeRates.lastUpdated') }}: {{ formatDate(rate.lastUpdated) }}
              </div>
              <v-divider
                v-if="index !== exchangeRates.length - 1"
                :key="`divider-${index}`"
              />
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Services from '@/services'

export default {
  name: 'Currencies',
  data () {
    return {
      currencies: [],
      exchangeRates: []
    }
  },
  async created () {
    this.currencies = this.$store.getters.allCurrencies.map(c => ({
      currencyId: c.id,
      active: c.isActive,
      description: c.description,
      loading: false
    }))
    await this.loadExchangeRates()
  },
  methods: {
    async currencyChange (item) {
      item.loading = true
      try {
        await Services.put('Currency/UpdateCurrency', {
          currencyId: item.currencyId,
          active: item.active
        })
        await this.$store.dispatch('currencies')
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
      } finally {
        item.loading = false
      }
    },
    async loadExchangeRates () {
      try {
        const response = await Services.get('Currency/GetCurrencyExchangeRates')
        this.exchangeRates = response.data.map(rate => ({
          id: rate.id,
          currency: rate.currency,
          currencyName: rate.currencyName,
          exchangeRate: rate.exchangeRate,
          lastUpdated: rate.lastUpdated,
          loading: false
        }))
      } catch (error) {
        console.error('Error loading exchange rates:', error)
        await this.$store.dispatch('setErrorNotification', this.$t('common.error'))
      }
    },
    async updateExchangeRate (rate) {
      if (!rate.exchangeRate || rate.exchangeRate <= 0) {
        await this.$store.dispatch('setErrorNotification', this.$t('currencies.exchangeRates.invalidRate'))
        await this.loadExchangeRates()
        return
      }

      rate.loading = true
      try {
        await Services.put('Currency/UpdateCurrencyExchangeRate', {
          currency: rate.currency,
          exchangeRate: parseFloat(rate.exchangeRate)
        })
        await this.loadExchangeRates()
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
      } catch (error) {
        console.error('Error updating exchange rate:', error)
        await this.$store.dispatch('setErrorNotification', this.$t('common.error'))
        await this.loadExchangeRates()
      } finally {
        rate.loading = false
      }
    },
    formatDate (date) {
      if (!date || date === '0001-01-01T00:00:00') return '-'
      return new Date(date).toLocaleString(this.$i18n.locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>
